export const REPORT_PATROL_TYPES = [
    // { _id: 'PATROL_POINTS_COMPLETED', name: 'str.report.settings.patrol_type.patrol_points_completed' },
    // { _id: 'PATROL_POINTS_INCOMPLETED', name: 'str.report.settings.patrol_type.patrol_points_incompleted' },
    // { _id: 'PATROL_POINTS_NOT_VISITED', name: 'str.report.settings.patrol_type.patrol_points_not_visited' },
    { _id: 'ALL_PATROLS', name: 'str.report.settings.patrol_type.all' },
    { _id: 'ALONE_PATROLS', name: 'str.report.settings.patrol_type.alone_patrol' },
]

export const REPORT_PATROL_TYPE_LIST = {
    // PATROL_POINTS_COMPLETED: 'PATROL_POINTS_COMPLETED',
    // PATROL_POINTS_NOT_VISITED: 'PATROL_POINTS_NOT_VISITED',
    // PATROL_POINTS_INCOMPLETED: 'PATROL_POINTS_INCOMPLETED',
    ALL_PATROLS: 'ALL_PATROLS',
    ALONE_PATROLS: 'ALONE_PATROLS',
}

export const PATROL_POINTS_TYPE = {
    TAG_RFID_125: 'TAG_RFID_125',
    QRCODE: 'QRCODE',
    SUPERVISION: 'SUPERVISION',
}
